import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!orderNumber.trim()) return;
    setLoading(true);
    try {
      const num = orderNumber.trim().toUpperCase();
      await api.get(`/orders/lookup/${num}`);
      navigate(`/order/success/${num}`);
    } catch {
      toast.error("Order not found. Double-check the number.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="track-page" className="min-h-screen grain-overlay">
      <SiteHeader />
      <main className="max-w-2xl mx-auto px-6 md:px-12 py-20">
        <p className="label-eyebrow">Track</p>
        <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl tracking-tighter">
          Where&rsquo;s my coffee?
        </h1>
        <p className="mt-3 text-[#4A4341]">
          Enter the order number from your confirmation to see its status.
        </p>
        <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3">
          <Input
            data-testid="track-order-input"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
            placeholder="CB-XXXXXX"
            className="bg-white border-black/10 focus-visible:ring-1 focus-visible:ring-[#C05A46] font-mono-jet"
          />
          <Button
            type="submit"
            disabled={loading}
            data-testid="track-order-submit"
            className="btn-brand rounded-full px-6 py-6 text-sm font-semibold"
          >
            {loading ? "Looking up…" : "Find order"}
          </Button>
        </form>
      </main>
    </div>
  );
}
